/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { QualificationsApi } from '../api/qualifications.api';
import { switchMap, map } from 'rxjs/operators';
import { QualificationsData, Qualifications } from '../../../interfaces/masters/qualifications';

@Injectable()
export class QualificationsService extends QualificationsData {

  constructor(private api: QualificationsApi) {
    super();
  }


  list(): Observable<Qualifications[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Qualifications>{
      return this.api.getById(url);
  }

  create(url: string, data:Qualifications): Observable<Qualifications> {
    return this.api.add(url,data);
  }

  update(url: string, data:Qualifications): Observable<Qualifications> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
